module.exports = __webpack_public_path__ + "static/media/image (23).cb9715ed.jpg";